import { get, post } from "../../network/endpoint"
import { dispatchHandler, success } from "services/utils/action"
import * as ActionTypes from "services/state/action-types"
import { BFF } from "services/network/routes"

export function sendUsagesByReportType(
  {
    productKey,
    contractKey,
    email,
    reportType,
    fileExtension,
    usagesDetailType
  },
  callback
) {
  return (dispatch) => {
    const config = {
      pathValues: { productKey, contractKey },
      data: { email, reportType, fileExtension, usagesDetailType }
    }
    const request = post("sendUsageFiles", config)

    dispatch({
      type: ActionTypes.SEND_USAGES_BY_REPORT_TYPE,
      payload: request
    }).then(success(callback))
  }
}

export function getUsageProfiles(
  { productKey, contractKey },
  callback,
  callbackFail
) {
  return (dispatch) => {
    const config = { pathValues: { productKey, contractKey }, client: BFF }
    const request = get("getUsageProfiles", config)

    dispatch({
      type: ActionTypes.GET_USAGE_PROFILE,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getUsageProfilesConsolidated(data, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: data,
      client: BFF,
      data
    }
    const request = get("getUsageProfilesConsolidated", config)

    return dispatch({
      type: ActionTypes.GET_USAGE_PROFILE_CONSOLIDATED,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function sendUsageProfileFiles(
  { productKey, email },
  customerData,
  callback
) {
  return (dispatch) => {
    const config = {
      pathValues: { productKey },
      data: {
        customerName: customerData.name,
        customerSegment: customerData.customerSegment,
        email
      },
      client: BFF
    }

    const request = post("sendUsageProfileFiles", config)

    return dispatch({
      type: ActionTypes.SEND_USAGE_PROFILE_FILES,
      payload: request
    }).then(success(callback))
  }
}

export function downloadUsageProfilesFiles(
  data,
  customerData,
  callback,
  callbackFail
) {
  return (dispatch) => {
    const config = {
      pathValues: { productKey: data.serviceId },
      data: {
        customerName: customerData.name,
        customerSegment: customerData.customerSegment,
        email: customerData.email
      },
      client: BFF
    }

    const request = post("downloadUsageProfilesFiles", config)

    return dispatch({
      type: ActionTypes.DOWNLOAD_USAGE_PROFILE_FILES,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}



// WEBPACK FOOTER //
// ./src/services/state/usage/action.js